import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServiceAttendance {
    lookupService = new APIServiceLookUp();

    async setAttendance(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}attendance/setAttendance`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async updateAttendance(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}attendance/updateAttendance`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getAllAttandance(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}attendance/getAllAttandance`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }
}